import React from 'react';
import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const BackButton = ({ onClick, sx = {} }) => (
	<Button
		startIcon={<ArrowBackIcon />}
		onClick={onClick}
		variant="text"
		size="small"
		sx={{
			mb: { xs: 2, md: 3 },
			px: 1,
			ml: -1,
			color: 'text.secondary',
			'&:hover': { color: 'text.primary', bgcolor: 'transparent' },
			...sx,
		}}
	>
		Back to Jobs
	</Button>
);

export default BackButton;
